import { render, staticRenderFns } from "./ChecklistGreenIcon.vue?vue&type=template&id=0a489164"
import script from "./ChecklistGreenIcon.vue?vue&type=script&lang=js"
export * from "./ChecklistGreenIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports